module.exports = __webpack_public_path__ + "img/pic1-2.fae0d969.png";